<template>
  <div class="input_cell">
    <textarea v-if="type == 'textarea'"
              class="input"
              v-model="content"
              value="content"
              :maxlength="maxlength"
              :placeholder="placeholder"
              rows="5"
              cols="5"
              @focus="onFocus"
              @blur="onBlur"
    />
    <input
      v-else
      class="input"
      v-model="content"
      value="content"
      :maxlength="maxlength"
      :placeholder="placeholder"
      :type="type"
      @focus="onFocus"
      @blur="onBlur"
    />

    <div class="clear_box" v-if="clearable && content && isFocus" @click="content = ''">
      <img src="../../assets/components/icon_clear.png" class="clear_icon"/>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: { type: String},
    placeholder: { type: String},
    maxlength: { type: Number},
    type: { type: String},
    clearable: { type: Boolean, default:true},//是否可清除
  },
  watch: {
    content(newValue) {
      let result = newValue
      if(newValue.length > this.maxlength) {
        result = newValue.slice(0,this.maxlength)
        this.content = result
      }

      this.$emit('input', result)
    }
  },
  data() {
    return {
      content:'',
      isFocus:false,
    };
  },
  created() {
    this.content = this.value
  },
  methods: {
    onFocus(){
      this.isFocus = true
    },
    onBlur(){
      setTimeout(()=>{
        this.isFocus = false
      }, 100)
    },
  },
};
</script>
<style lang="less" scoped>
.input_cell {
  display: flex;
  align-items: center;
  min-height:44px;
  flex:1;

  .input{
    width:100%;
    height:100%;
    font-size: 16px;
    padding-left: 15px;
    color:#191F25;
    background: transparent;
  }
  .clear_box{
    display: flex;
    align-items: center;
    height:100%;
    .clear_icon{
      width:16px;
      height:16px;
      margin: auto 15px;
    }
  }

}
</style>
